module.exports = __webpack_public_path__ + "static/media/southamerica-final.8b06418d.png";